import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { Observable } from "rxjs";

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {

  private readonly xsrfHeaderName  = 'X-XSRF-TOKEN';
  private readonly xsrfMetatagName = 'xsrf-token';
  private readonly xsrfToken: HTMLMetaElement;

  constructor(private readonly meta: Meta) {
    this.xsrfToken = this.meta.getTag(`name=${this.xsrfMetatagName}`); 
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.xsrfToken !== null && !request.headers.has(this.xsrfHeaderName)) {
      request = request.clone({ headers: request.headers.set(this.xsrfHeaderName, this.xsrfToken.content) });
    }
    
    return next.handle(request);
  }
}